import "core-js/modules/es.array.push.js";
export default {
  props: {
    tag: {
      type: String,
      default: ''
    },
    tagsData: {
      type: Array,
      default: []
    },
    length: {
      type: [String, Number],
      default: 'all'
    }
  },
  data() {
    return {
      tagBgColor: ['#11a8cd', '#F8B26A', '#67CC86', '#E15B64', '#F47E60', '#849B87'],
      tagStyleList: []
    };
  },
  created() {
    for (let i = 0, tagH = this.tags.length; i < tagH; i++) {
      this.tagStyleList.push(this.getTagStyle());
    }
  },
  computed: {
    tags() {
      if (this.length === 'all') {
        return this.tagsData;
      } else {
        return this.tagsData.slice(0, this.length);
      }
    }
  },
  methods: {
    getTagStyle() {
      const tagBgColor = this.tagBgColor;
      const randomColor = tagBgColor[Math.floor(Math.random() * tagBgColor.length)];
      return `background: ${randomColor};--randomColor:${randomColor};`;
    }
  }
};